// Offline outbox for score ops: persisted per event in localStorage, replayed on top of server docs.
const key = (eventId) => `tga-outbox-${eventId}`;
const cacheKey = (eventId) => `tga-event-${eventId}`;

export const opKey = (op) => `${op.dayId}|${op.groupIdx}|${op.holeIdx}|${op.submit ? "submit" : op.attest ? `att:${op.playerId}` : op.playerId ? `p:${op.playerId}` : "bbb"}|${op.scorerId || ""}`;

export function loadOutbox(eventId) {
  try { return JSON.parse(localStorage.getItem(key(eventId)) || "[]"); } catch { return []; }
}
export function saveOutbox(eventId, ops) {
  try { localStorage.setItem(key(eventId), JSON.stringify(ops)); } catch (e) { console.error("outbox persist failed", e); }
}
export function mergeOps(existing, incoming) {
  const map = new Map(existing.map((o) => [opKey(o), o]));
  for (const o of incoming) map.set(opKey(o), o);
  return [...map.values()];
}

export function cacheEvent(eventId, doc) {
  try { localStorage.setItem(cacheKey(eventId), JSON.stringify(doc)); } catch (e) { console.error("event cache failed", e); }
}
export function loadCachedEvent(eventId) {
  try { return JSON.parse(localStorage.getItem(cacheKey(eventId)) || "null"); } catch { return null; }
}

const emptyHole = () => ({ strokes: null, fairway: null, gir: null, putts: null });
const emptyBbb = () => ({ bingo: null, bango: null, bongo: null });

// Mutates and returns doc. Mirrors backend _apply_score_ops.
export function applyOps(doc, ops) {
  if (!doc || !ops?.length) return doc;
  for (const op of ops) {
    const day = (doc.days || []).find((d) => d.id === op.dayId);
    const g = day?.groups?.[op.groupIdx];
    if (!g || op.holeIdx < 0 || op.holeIdx > 17) continue;
    if (op.submit) {
      if (op.submit.value === false) { g.submitted = null; g.attestations = {}; }
      else g.submitted = { at: new Date().toISOString(), by: op.submit.by || "", byOrganizer: true };
      continue;
    }
    if (op.attest && op.playerId) {
      if (!(g.playerIds || []).includes(op.playerId)) continue;
      g.attestations = g.attestations || {};
      if (op.attest.value === false) { if (!g.submitted) delete g.attestations[op.playerId]; }
      else if (!g.submitted) {
        g.attestations[op.playerId] = { at: new Date().toISOString(), by: op.attest.by || op.playerId, onBehalf: !!op.attest.onBehalf, auto: !!op.attest.auto };
        if (!g.submitted && (g.playerIds || []).every((p) => g.attestations[p])) g.submitted = { at: new Date().toISOString(), by: "attest", auto: !!op.attest.auto };
      }
      continue;
    }
    if (g.submitted) continue;
    if (op.hole && op.playerId) {
      day.handicaps = day.handicaps || {};
      if (typeof day.handicaps[op.playerId] !== "number") day.handicaps[op.playerId] = (doc.players || []).find((p) => p.id === op.playerId)?.handicap || 0;
      g.scores = g.scores || {};
      const arr = Array.from({ length: 18 }, (_, i) => g.scores[op.playerId]?.[i] || emptyHole());
      arr[op.holeIdx] = op.hole;
      g.scores[op.playerId] = arr;
      if (op.scorerId) {
        g.cards = g.cards || {};
        g.cards[op.scorerId] = g.cards[op.scorerId] || {};
        const strokes = Array.from({ length: 18 }, (_, i) => g.cards[op.scorerId][op.playerId]?.[i] ?? null);
        strokes[op.holeIdx] = op.hole.strokes ?? null;
        g.cards[op.scorerId][op.playerId] = strokes;
      }
    }
    if (op.bbb) {
      const bbb = Array.from({ length: 18 }, (_, i) => g.bbb?.[i] || emptyBbb());
      bbb[op.holeIdx] = op.bbb;
      g.bbb = bbb;
    }
  }
  return doc;
}
